import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders the sections of a view with a divider between each two of them.
 *
 * Children that render nothing (`false`, `null`) are left out before the
 * dividers are placed, so a missing section never leaves two dividers - or
 * one directly under the header's own - behind.
 */
const Sections = ({ children }) =>
  React.Children.toArray(children).map((child, index) => (
    <React.Fragment key={child.key}>
      {index > 0 && <div className="view-divider" />}
      {child}
    </React.Fragment>
  ));

Sections.propTypes = {
  children: PropTypes.node,
};

export default Sections;
